import {
  IApplicationBackEndModel,
  IApplicationEditFrontEndModel,
} from "../../types";
import { editContentConfig } from "../edit/editContentConfig";
import { EducationType } from "../../../school/constants/types";
import { ApiRoutes } from "../../../../constants/apiRoutes";

export function parseToEditProgramApplicationBackEndModel(
  frontEndData: IApplicationEditFrontEndModel,
): IApplicationBackEndModel {
  const stepName: string = editContentConfig.stepName!;
  const educationType = frontEndData.injectedData.educationType;

  let applicationFormIds;

  switch (educationType) {
    case EducationType.Language:
      applicationFormIds =
        frontEndData.injectedData.course!.applicationForms?.map(
          (appForm) => appForm.id,
        ) || [];
      break;
    case EducationType.Secondary:
    case EducationType.Higher:
      applicationFormIds =
        frontEndData.injectedData.program!.academic.applicationForms?.map(
          (appForm) => appForm.id,
        ) || [];
      break;
  }

  const applicationDocs = Object.entries(
    frontEndData[stepName]?.applicationFiles || {},
  ).map(([applicationFormId, uploadedFile]: any) => ({
    applicationFormId,
    fileId: uploadedFile.id,
  }));

  const requiredDocs = Object.entries(
    frontEndData[stepName]?.requiredDocs || {},
  ).map(([requiredDocId, uploadedFile]: any) => ({
    requiredDocId,
    fileId: uploadedFile.id,
  }));

  const extraDocs =
    [
      ...frontEndData.injectedData.extraDocs,
      ...(frontEndData[stepName]?.extraDocs || []),
    ].map((extDoc) => ({ fileId: extDoc.id })) || [];

  const receivedApplicationFiles =
    frontEndData.injectedData.filledForms
      ?.filter(
        (reqDoc) =>
          reqDoc.filled?.applicationFormId &&
          applicationFormIds?.includes(reqDoc.filled?.applicationFormId) &&
          !!reqDoc.filled,
      )
      .map((appFiles) => ({
        applicationFormId: appFiles.filled?.applicationFormId,
        fileId: appFiles.filled?.file.id,
      })) || [];

  const receivedRequiredFiles =
    frontEndData.injectedData.requiredDocs
      ?.filter((reqDoc) => !!reqDoc.filled)
      .map((recDocFile) => ({
        requiredDocId: recDocFile.filled?.requiredDocId,
        fileId: recDocFile.filled?.file.id,
      })) || [];

  return {
    id: frontEndData.id,
    studentId: frontEndData.injectedData.student.id,
    ...((educationType === EducationType.Higher ||
      educationType === EducationType.Secondary) && {
      intakeId: frontEndData.step1.intake.id,
    }),
    branchId: frontEndData.injectedData.branch.id,
    isLinkConfirmed: frontEndData.step1.isLinkConfirmed,
    filledForms: [...applicationDocs, ...receivedApplicationFiles],
    requiredDocs: [...requiredDocs, ...receivedRequiredFiles],
    comment: frontEndData.injectedData.comment,
    extraDocs,
  };
}
